module.exports = __webpack_public_path__ + "img/distanceWedge1.ff24a42c.png";